import { Injectable } from '@angular/core';
import { DataTableColumn } from '../components/data-table';

@Injectable({
  providedIn: 'root',
})
export class TableConfigurationOverrideService {
  private overrideColumns: Map<string, DataTableColumn[]> = new Map();

  overrideAllColumnsForTable(params: {
    uniqueTableId: string;
    allColumns: DataTableColumn[];
  }): void {
    const { uniqueTableId, allColumns } = params;
    this.overrideColumns.set(uniqueTableId, allColumns);
  }

  getOverrideTableConfiguration(
    uniqueTableId: string
  ): DataTableColumn[] | undefined {
    return this.overrideColumns.get(uniqueTableId);
  }
}
